
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers/public-notice",
      function () {
        return require("private-next-pages/careers/public-notice.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careers/public-notice"])
      });
    }
  